import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import type { CallEntity } from '@tradecafe/aiagent-sdk';
import type { DeepReadonly } from '@tradecafe/types/utils';
import * as CallActions from './call.actions';

export const callsFeatureKey = 'calls'
export interface CallsState extends EntityState<DeepReadonly<CallEntity>> {
}

const selectId = (call: DeepReadonly<CallEntity>) => call.call_id

export const adapter = createEntityAdapter<DeepReadonly<CallEntity>>({ selectId })

const initialState: CallsState = adapter.getInitialState({
})

export const callsReducer = createReducer(
  initialState,
  on(CallActions.loadCallsSuccess,
    (state, action) =>
      adapter.upsertMany(action.calls, state)),
) 